import { ReactNode, SyntheticEvent } from 'react';
import { CheckboxVariant, FunnelImage } from 'core/flow/entities';
import { Checkbox } from '../../Checkbox';
import { FormControlLabel } from '../../FormControlLabel';
import { Image } from '../../Image';
import { Typography } from '../../Typography';

type CheckboxPillProps = {
  checked: boolean;
  value: string;
  image?: FunnelImage;
  onAnswerClick: (value: string, checked: boolean) => void;
  children?: ReactNode;
};

export const CheckboxPill = ({
  checked,
  value,
  onAnswerClick,
  children,
  image,
  ...otherProps
}: CheckboxPillProps) => {
  const onChange = (event: SyntheticEvent<Element, Event>, selected: boolean) => {
    onAnswerClick((event.target as HTMLInputElement).value, selected);
  };

  const Control = (
    <>
      {image && <Image alt={image.alt} src={image.src} width={20} height={20} />}
      <Typography variant="bodyMediumSemiBold">{children}</Typography>
    </>
  );

  return (
    <FormControlLabel
      control={<Checkbox />}
      label={Control}
      labelPlacement="start"
      checked={checked}
      onChange={onChange}
      value={value}
      variant={CheckboxVariant.PILL}
      {...otherProps}
    />
  );
};
